/**
 * 将错误转为字符串，避免在日志中持有对象引用导致内存无法释放
 * @param err 任意错误或对象
 * @returns 错误信息字符串
 */
export function toErrorString(err: unknown): string {
  if (err instanceof Error) {
    const stack = err.stack ? `\n${err.stack}` : '';
    return `${err.name}: ${err.message}${stack}`;
  }
  if (typeof err === 'object' && err !== null) {
    try {
      return JSON.stringify(err);
    } catch {
      return String(err);
    }
  }
  return String(err);
}
